import React from 'react'

import { Form, Col } from '_zari/core'

const NumeroDocumentoFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='NUM DOC' htmlFor='input-numeroDocumento' md={4} />
      <Col md={8}>
        <Form.InputText id='input-numeroDocumento' name='input-numeroDocumento' placeholder={value} disabled />
      </Col>
    </Form.Group>
  )
}

export default NumeroDocumentoFormGroup
